import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const OEMetricsPlugin = createPlugin({
  id: 'oe-metrics',
  routes: {
    root: rootRouteRef,
  },
});

export const OEMetricsPage = OEMetricsPlugin.provide(
  createRoutableExtension({
    name: 'OeMetricsPage',
    component: () =>
      import('./components/ExampleComponent').then(m => m.ExampleComponent),
    mountPoint: rootRouteRef,
  }),
);
